module.exports = __webpack_public_path__ + "img/bandcamp.1c3b2046.png";